module.exports = __webpack_public_path__ + "static/media/lawyer.5d2a8b54.jpg";